import { render, staticRenderFns } from "./book-notification.vue?vue&type=template&id=e04c0400&functional=true"
import script from "./book-notification.vue?vue&type=script&lang=js"
export * from "./book-notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports